import React, { FunctionComponent, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { Person } from "../../models/Person";
import { thunkFetchAdmins } from "../../store/users/actions";

interface AdminSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: Person) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
}

export const AdminSelect: FunctionComponent<AdminSelectProps> = ({
  label = "Administrator",
  onSelected,
  onChange,
  variant = "standard",
  value = [],
  error = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const administrators =
    useSelector<AppState, ReadonlyArray<Person>>(
      s => s.users.admins as ReadonlyArray<Person>
    ) || [];

  const [state, setState] = useState<ReadonlyArray<Person>>([]);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let person = state.find(admin => admin.id === event.target.value);

      if (person) {
        onSelected(person);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    // load if not loaded
    if (!administrators || !administrators.length) {
      dispatch(thunkFetchAdmins());
    }
  }, []);

  useEffect(() => {
    return setState(
      [...administrators].sort((a, b) => (a.name > b.name ? 1 : -1))
    );
  }, [administrators]);

  return (
    <FormControl variant={variant} className={props.className} error={error}>
      <InputLabel
        id="cluster-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="market-select-label"
        id="market-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(person => (
            <MenuItem key={person.id} value={person.id}>
              {person.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
